import { bufferToHexString } from '@iotize/common/byte-converter';
import { CodeError } from '@iotize/common/error';
import { TapResponseStatusError } from '@iotize/tap';

import { UsernamePassword } from './definitions';

export class TapAuthError extends CodeError<TapAuthError.Code> {
  static tapRequestError(params: any, err: Error) {
    return new TapAuthError(
      TapAuthError.Code.TapRequestError,
      `Login failed. ${err.message}`,
      err,
    );
  }
  static tooManyLoginFailedError(
    params: UsernamePassword,
    err: TapResponseStatusError,
  ) {
    return new TapAuthError(
      TapAuthError.Code.TooManyLoginAttempt,
      `Login failed due to too many login attempt. You must wait before trying to login again.`,
      err,
    );
  }

  static invalidCredentialsError(
    credentials: UsernamePassword,
    err: TapResponseStatusError,
  ) {
    return new TapAuthError(
      TapAuthError.Code.InvalidCredentials,
      `Login failed. Given username or password is not valid.`,
      err,
    );
  }

  constructor(
    code: TapAuthError.Code,
    message: string,
    public cause?: Error,
  ) {
    super(message, code);
  }
}

export namespace TapAuthError {
  export enum Code {
    InvalidServerProof = 'TapAuthErrorInvalidServerProof',
    ScramDisabled = 'TapAuthErrorScramDisabled',
    InvalidCredentials = 'TapAuthErrorInvalidCredentials',
    TooManyLoginAttempt = 'TapAuthErrorTooManyLoginAttempt',
    TapRequestError = 'TapAuthErrorTapRequestError',
  }

  export class InvalidServerKey extends TapAuthError {
    constructor(
      public deviceServerProof: Uint8Array,
      public expectedServerProof: Uint8Array,
    ) {
      super(
        Code.InvalidServerProof,
        `Login fail invalid server proof ('${bufferToHexString(
          deviceServerProof,
        )}' != '${bufferToHexString(expectedServerProof)}') `,
      );
    }
  }
}
